module.exports = __webpack_public_path__ + "assets/a00fdb5d1a5432f088e132d8a8be946e.png";